import { render, staticRenderFns } from "./GraficosCustom.vue?vue&type=template&id=f138d8d8&scoped=true&"
import script from "./GraficosCustom.vue?vue&type=script&lang=js&"
export * from "./GraficosCustom.vue?vue&type=script&lang=js&"
import style0 from "./GraficosCustom.vue?vue&type=style&index=0&id=f138d8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138d8d8",
  null
  
)

export default component.exports